module.exports = __webpack_public_path__ + "static/img/banner (1).ad34b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner (1).jpg
// module id = ER6U
// module chunks = 73